module.exports = __webpack_public_path__ + "img/bingo_ball-86.d011cf12.png";